export default "__VITE_ASSET__$KIq0j0t__"